/* eslint-disable @typescript-eslint/ban-ts-comment */

// VENDOR: i18n
import { createI18n } from 'vue-i18n'

// PERSONAL LIBS
import messages from '../'
import { defaultLanguage } from './constants'
import { getMiniISO } from './helpers'

// Create I18n instance
export const i18n = createI18n({
  locale: defaultLanguage,
  legacy: false,
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  fallbackLocale: 'en-US',
  // warnHtmlInMessage: process.env.NODE_ENV === 'production' ? 'off' : 'on',
  warnHtmlInMessage: 'off',
  messages
})

// @ts-ignore
export const $t = i18n.global.t.bind(i18n)

export const getLanguage = async (): Promise<string> => {
  let language = defaultLanguage

  // Defines default language (browser language)
  language = getMiniISO(navigator.language.toLowerCase())

  return language
}
